import React, { memo } from 'react'
import { Box } from '@chakra-ui/core'
import { Task } from 'constants/interfaces'
import { TaskV2ListItem } from 'components/Tasks/TaskV2ListItem'
import { SectionHeader } from './SectionHeader'
import useLocaleText from 'components/useLocaleText'

interface TasksFilteredViewProps {
  uncompletedTasks: Task[]
  completedTasks: Task[]
  userId: string
  selectedTaskID?: string | null
  onTaskSelect?: (tid: string) => void
  onTaskClose?: () => void
}

export const TasksFilteredView = memo(
  ({ uncompletedTasks, completedTasks, userId, selectedTaskID, onTaskSelect, onTaskClose }: TasksFilteredViewProps) => {
    const uncomp_tasks = useLocaleText('uncomp_tasks')
    const comp_tasks = useLocaleText('comp_tasks')

    return (
      <Box>
        {uncompletedTasks.length > 0 && (
          <>
            <SectionHeader title={uncomp_tasks} />
            {uncompletedTasks.map((t) => (
              <TaskV2ListItem
                key={t.tid}
                task={t}
                uid={userId}
                isPersonalView={true}
                selectedTaskID={selectedTaskID}
                onTaskSelect={onTaskSelect}
                onTaskClose={onTaskClose}
              />
            ))}
          </>
        )}

        {completedTasks.length > 0 && (
          <>
            <SectionHeader title={comp_tasks} />
            {completedTasks.map((t) => (
              <TaskV2ListItem
                key={t.tid}
                task={t}
                uid={userId}
                isPersonalView={true}
                selectedTaskID={selectedTaskID}
                onTaskSelect={onTaskSelect}
                onTaskClose={onTaskClose}
              />
            ))}
          </>
        )}
      </Box>
    )
  }
)
